import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { API_BASE_URL } from '@synergy/config';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { BonusSettlementsOverviewApi } from '../api/bonus-settlements-overview-api';

const api = new BonusSettlementsOverviewApi(API_BASE_URL);

export const fetchBonusSettlements = createAsyncThunk(
    'bonus-settlements/fetchBonusSettlements',
    async (searchParams: URLSearchParams, thunkAPI) => {
        const response = await api.getBonusSettlementsOverview(searchParams);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));

            return thunkAPI.rejectWithValue(null);
        }

        return response.result;
    }
);

export const updateBonusSettlement = createAsyncThunk(
    'bonus-settlements/updateBonusSettlement',
    async (params: { id: number; payout: number }, thunkAPI) => {
        const response = await api.updateBonusSettlement(params.id, params.payout);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));

            return thunkAPI.rejectWithValue(null);
        }

        // Saving said nothing at all before, so the quota looked unchanged
        // until the list was read again (#2211).
        thunkAPI.dispatch(
            Snackbar.enqueue(Snackbar.PoolNotification.success('app.snackbar.bonusSettlements.payoutSaved'))
        );

        return params;
    }
);

export const deleteBonusSettlement = createAsyncThunk(
    'bonus-settlements/deleteBonusSettlement',
    async (params: { id: number }, thunkAPI) => {
        const response = await api.deleteBonusSettlement(params.id);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));

            return thunkAPI.rejectWithValue(null);
        }
        thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.success('app.bonusSettlements.action.remove.success')));

        return params;
    }
);

export const generateBonusSettlement = createAsyncThunk(
    'bonus-settlements/generateBonusSettlement',
    async (params: { year: number; isEmpty: boolean }, thunkAPI) => {
        const response = await api.generateBonusSettlement(params.year, params.isEmpty);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));

            return thunkAPI.rejectWithValue(null);
        }

        thunkAPI.dispatch(
            Snackbar.enqueue(Snackbar.PoolNotification.success('app.snackbar.bonusSettlements.generateSuccess'))
        );

        return response.result;
    }
);

export const createReclamation = createAsyncThunk(
    'bonus-settlements/createReclamation',
    async (id: number, thunkAPI) => {
        const response = await api.createReclamation(id);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));

            return thunkAPI.rejectWithValue(null);
        }

        thunkAPI.dispatch(
            Snackbar.enqueue(Snackbar.PoolNotification.success('app.snackbar.bonusSettlements.reclaimCreateSuccess'))
        );

        return response.result;
    }
);

export const resetBonusSettlementsState = createAction('bonus-settlements/resetBonusSettlementsState');
